/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountsModel {
    getFixupPrototypeFunction() { return ServiceAccountsModel.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountsModel>): ServiceAccountsModel {
        let obj = Object.assign(new ServiceAccountsModel(), model);
        ServiceAccountsModel.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountsModel>): ServiceAccountsModel {
        if (!model) return null;
        return ServiceAccountsModel.newInstance(<ServiceAccountsModel> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountsModel) {
        if (!obj) return;

        models.ServiceAccountsModel.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountsModel): boolean {
        Object.setPrototypeOf(obj, ServiceAccountsModel.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * ID of the cloud account
     */
    cloud_account_id: string;

    /**
     * ID of the tenant
     */
    tenant_id: string;

    /**
     * Name of the cloud account
     */
    cloud_account_name: string;

}
